import { store } from '@src/state/store';
import { getCurrentGame } from '@src/state/selectors/selector_game';
import { pushEventQueue } from '@src/state/slices/slice_game';
import { Game } from '@src/lib/types';

export default () => (data: any) => {
  if (!data || !data.gameId) return;

  const currentGame: Game | null = getCurrentGame(store.getState());
  if (currentGame === null)
    throw new Error('[_reverseTurn] game not found in root state');

  if (data.gameId == currentGame.gameId) {
    console.log('REVERSE');
    store.dispatch(
      pushEventQueue({ message: 'REVERSE', showToast: true, sound: 'action' }),
    );
  }
};
